import { createContext } from 'react';
import { DateFilterEnum, PeriodFilterEnum } from '@/ui';
import { ReportDateRange } from '../../util/report-date-filter';

export interface ReportsFilterContextData {
    preset: DateFilterEnum;
    range: ReportDateRange;
    timezone: string;
    period: PeriodFilterEnum;
    /** The bucket sizes the current range is long enough to be grouped by. */
    allowedPeriods: PeriodFilterEnum[];
    setFilter: (filter: {
        date?: {
            preset: DateFilterEnum;
            range: ReportDateRange | null;
        };
        period?: PeriodFilterEnum;
    }) => void;
}

export const ReportsFilterContext = createContext<
    ReportsFilterContextData | undefined
>(undefined);
